export default "__VITE_ASSET__BZsyYYDF__"